// Controller.js version 2.01.20210702

import CommModule from './CommModule.js';
const NodeRSA = require('node-rsa');

export default class Controller {
	constructor(controller_info, receiver) {
		// Information required for login
		if (controller_info.ip_addr == null && controller_info.ip_addr == undefined) {
			throw ({ 'message': 'in_ctrl_addr' })
		} else if (controller_info.name == null && controller_info.name == undefined) {
			throw ({ 'message': 'controller name not found' }) // add to string table
		} else if (receiver == null && receiver == undefined) {
			throw ({ 'message': 'no receiver' }) // add to string table
		}
		this.ip_addr = controller_info.ip_addr; // throw exception if not exists
		this.mac_addr = controller_info.mac_addr;
		this.ssc_connect = controller_info.ssc_connect;
		this.ssc_url = controller_info.ssc_url;
		this.name = controller_info.name;
		//this.hwkey = controller_info.hwkey;
		this.receiver = receiver;
		this.model = controller_info.model;
		this.version = controller_info.version;

		// Create Comm Module
		this.comm_module = new CommModule(this);

		// Is the controller logged in?
		this.is_logged_in = false;

		// Check if controller is still in logging in process
		this.is_logging_in = false;

		// User information
		this.username = '';
		this.password = '';
		this.available_functions = {
			"sp_range": false,
			"rc_proh": false,
			"schedule": false,
			"setback": false,
			"interlock": false,
			"scene": false,
			"group": false,
			"history": false,
			"op_report": false,
			"err_report": false,
			"trend_graph": false,
			"energy_graph": false,
			"layout": false,
			"data": false,
			"ipcam": false,
			"msm": false,
			"change_over": false,
			"hotel_logic": false,
			"demand": false,
			"server_room": false,
			"ppd": false,
			"report": false,
			"billing": false,
			"db_access": false
		}
		this.auth = {
			"user_reg": false,
			"sp_proh": false,
			"mode_proh": false,
			"points": {}
		}
		this.user_class = 'Standard';

		this.op_command_src = '' // This is to check if op command is sent from operation screen or point setting

		// For MSM
		this.active_site = '';
		if (this.model == 'F10') {
			this.msm_avaliable_functions = { ...this.available_functions };
		}

		/*
		 * For display in version information (i.e. we cannot use controller name because for web version,
		 * this has to be unique. If we replace it with default controller name, localStorage cannot correctly 
		 * identify each controller.
		 */
		this.web_controller_name = '';
	}

	// For MSM
	setActiveSite(site_id) {
		this.active_site = site_id;
	}

	// Request login to SVM controller. The result will be back with login event. 
	// If true user logged in. if false, login was failed. 
	// This event is received by receiver object(loginStatus).
	login(user) {
		this.is_logging_in = true;
		this.username = user.username;
		this.password = user.password;
		this.uuid = user.uuid;
		// First connect websocket
		this.comm_module.connectToSVM();
	}

	// Logout from the controller.
	logout() {
		this.is_logged_in = false;
		this.comm_module.logout();
	}

	reboot() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'reboot';

		this.comm_module.send(packet);
	}

	getPointList() {
		// Get point id, attr and status from server
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'mplist';

		this.comm_module.send(packet);
	}

	getGroups() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'group';
		packet.data = ["get_groups"];

		this.comm_module.send(packet);
	}

	addGroup(group_info) {
		//["enc",null,["group",["add",{"name":"sect1","mp":["dtatcp1:1-00004","dtatcp1:1-00005"]}]]]
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'group';
		packet.data = ["add", group_info];
		this.comm_module.send(packet);
	}

	modifyGroup(group_info) {
		//["enc",null,["group",["modify",["grp1",{"name":"sect2","mp":["dtatcp1:1-00006","dtatcp1:1-00007","dtatcp1:1-00008"]}]]]]
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'group';
		packet.data = ["modify", group_info];
		this.comm_module.send(packet);
	}

	deleteGroup(group_id) {
		//["enc",null,["group",["delete","grp1"]]]
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'group';
		packet.data = ["delete", group_id];

		this.comm_module.send(packet);
	}

	exec(command) {
		// eg. [null,null,["group",["exec",["grp17", {"stat":"on"}]]]]
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'group';
		packet.data = ["exec", command];
		this.comm_module.send(packet);
	}

	operate(command) {
		this.op_command_src = 'operation';
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'op';
		packet.data = command;

		this.comm_module.send(packet);
	}

	getScene() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'scene';
		packet.data = ["get_scenes"];

		this.comm_module.send(packet);
	}

	addScene(scene_detail) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'scene';
		packet.data = ["add_scene", scene_detail];

		this.comm_module.send(packet);
	}

	modifyScene(scene) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'scene';
		packet.data = ["modify_scene", scene];

		this.comm_module.send(packet);
	}

	deleteScene(scene_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'scene';
		packet.data = ["delete_scene", scene_id];

		this.comm_module.send(packet);
	}

	executeScene(scene_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'scene';
		packet.data = ["exec", scene_id];

		this.comm_module.send(packet);
	}

	getSchedule() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["get_program"];

		this.comm_module.send(packet);
	}

	addScheduleProgram(program) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["add_program", program];

		this.comm_module.send(packet);
	}

	modifyScheduleProgram(program) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["modify_program", program];

		this.comm_module.send(packet);
	}

	enableScheduleProgram(program) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["enable", program];

		this.comm_module.send(packet);
	}

	deleteScheduleProgram(program_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["delete_program", program_id];

		this.comm_module.send(packet);
	}

	addPattern(pattern) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["add_pattern", pattern];

		this.comm_module.send(packet);
	}

	modifyPattern(pattern) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["modify_pattern", pattern];

		this.comm_module.send(packet);
	}

	deletePattern(pattern_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["delete_pattern", pattern_id];

		this.comm_module.send(packet);
	}

	addCalendar(calendar) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["add_calendar", calendar];

		this.comm_module.send(packet);
	}

	modifyCalendar(calendar) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["modify_calendar", calendar];

		this.comm_module.send(packet);
	}

	deleteCalendar(calendar_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'schedule';
		packet.data = ["delete_calendar", calendar_id];

		this.comm_module.send(packet);
	}

	getInterlock() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'interlock';
		packet.data = ["get_program"];

		this.comm_module.send(packet);
	}

	addInterlockProgram(program) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'interlock';
		packet.data = ["add_program", program];

		this.comm_module.send(packet);
	}

	modifyInterlockProgram(program) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'interlock';
		packet.data = ["modify_program", program];

		this.comm_module.send(packet);
	}

	enableInterlockProgram(program) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'interlock';
		packet.data = ["enable", program];

		this.comm_module.send(packet);
	}

	loadPPDPointList() {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ["ppd_point_list"];
		this.comm_module.send(packet);
	}

	loadOwnerInfo() {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["load_owner_info"];
		this.comm_module.send(packet);
	}

	saveCalcOption(calc_option) {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["save_calc_option", calc_option];
		this.comm_module.send(packet);
	}

	loadCalcOption() {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["load_calc_option"];
		this.comm_module.send(packet);
	}

	saveOwnerInfo(owner_info) {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ['save_owner_info', owner_info];
		this.comm_module.send(packet);
	}

	loadTenant() {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["load_tenant"];
		this.comm_module.send(packet);
	}

	saveTenant(tenant_info) {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["save_tenant", tenant_info];
		this.comm_module.send(packet);
	}

	saveHolidayCalendar(holiday_info) {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["save_holiday_calendar", holiday_info];
		this.comm_module.send(packet);
	}

	loadHolidayCalendar() {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["load_holiday_calendar"];
		this.comm_module.send(packet);
	}

	loadPriceInfo() {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["load_price_info"];
		this.comm_module.send(packet);
	}

	savePriceInfo(price_info) {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["save_price_info", price_info];
		this.comm_module.send(packet);
	}

	getBillData(bill_data) {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'bill';
		packet.data = ["get_bill_data", bill_data];
		this.comm_module.send(packet);
	}

	getPPD(param) {
		let packet = {}
		packet.param1 = 'enc'
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ["get_ppd", param];
		this.comm_module.send(packet);
	}

	deleteInterlockProgram(program_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'interlock';
		packet.data = ["delete_program", program_id];

		this.comm_module.send(packet);
	}

	getOption() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_option';

		this.comm_module.send(packet);
	}

	getSSC() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_ssc';

		this.comm_module.send(packet);
	}

	getAccess() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_access';

		this.comm_module.send(packet);
	}

	getMailServer() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_mail_server';

		this.comm_module.send(packet);
	}

	getNetwork() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_network';

		this.comm_module.send(packet);
	}

	getSSIDList() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_ssid_list';

		this.comm_module.send(packet);
	}

	getDeviceConnection() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_dev_con';

		this.comm_module.send(packet);
	}

	getControllerList() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_controller_list';

		this.comm_module.send(packet);
	}

	getAccounts() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_account_list';

		this.comm_module.send(packet);
	}

	getControllerInfo() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_controller_info';

		this.comm_module.send(packet);
	}

	getTimeInfo() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_time_info';

		this.comm_module.send(packet);
	}

	getTimezones() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'get_timezones';

		this.comm_module.send(packet);
	}

	addAccount(account) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'add_account';
		packet.data = account;

		this.comm_module.send(packet);
	}

	modifyAccount(account) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'modify_account';
		packet.data = account;

		this.comm_module.send(packet);
	}

	deleteAccount(name) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'delete_account';
		packet.data = name;

		this.comm_module.send(packet);
	}

	setPassword(user_detail) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'change_passwd';
		packet.data = user_detail;

		this.comm_module.send(packet);
	}

	setPointSettings(point_settings) {
		this.op_command_src = 'point_settings';

		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'op';
		packet.data = point_settings;

		this.comm_module.send(packet);
	}

	getChangeOverGroups() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'changeover';
		packet.data = ["get_groups"];

		this.comm_module.send(packet);
	}

	addChangeover(changeover_info) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'changeover';
		packet.data = ["add", changeover_info];

		this.comm_module.send(packet);
	}

	modifyChangeover(changeover_info) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'changeover';
		packet.data = ["modify", changeover_info];

		this.comm_module.send(packet);
	}

	deleteChangeover(grp_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'changeover';
		packet.data = ["delete", grp_id];

		this.comm_module.send(packet);
	}

	enableChangeover(grp_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'changeover';
		packet.data = ["enable", grp_id];

		this.comm_module.send(packet);
	}

	setOption(option_settings) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_option';
		packet.data = option_settings;

		this.comm_module.send(packet);
	}

	setSSC(ssc) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_ssc';
		packet.data = ssc;

		this.comm_module.send(packet);
	}

	setNTP(ntp) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_ntp';
		packet.data = ntp;

		this.comm_module.send(packet);
	}

	setTimezone(timezone) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_timezone';
		packet.data = timezone;

		this.comm_module.send(packet);
	}

	setTime(time) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_time';
		packet.data = time;

		this.comm_module.send(packet);
	}

	setAccess(access) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_access';
		packet.data = access;

		this.comm_module.send(packet);
	}

	setMailServer(mail_server_settings) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_mail_server';
		packet.data = mail_server_settings;

		this.comm_module.send(packet);
	}

	setNetwork(network_settings) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_network';
		packet.data = network_settings;

		this.comm_module.send(packet);
	}

	//History
	getHistory(search_date) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['get_history', search_date];

		this.comm_module.send(packet);
	}

	// Report Settings
	loadReportSettings() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['load_report_setting'];

		this.comm_module.send(packet);
	}

	saveReportSettings(report_settings) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['save_report_setting', report_settings];

		this.comm_module.send(packet);
	}

	// Operation Info
	getOptimePointList() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['optime_point_list'];

		this.comm_module.send(packet);
	}

	getTotalOpTime(points) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['total_op_time', points];

		this.comm_module.send(packet);
	}

	// Not Used
	/*getHourlyOpTime(search_details){
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['hourly_op_time', search_details];
		
		this.comm_module.send(packet);
	}*/

	getDailyOpTime(search_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['daily_op_time', search_details];

		this.comm_module.send(packet);
	}

	getMonthlyOpTime(search_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['monthly_op_time', search_details];

		this.comm_module.send(packet);
	}

	// Error Info
	getDailyErrorInfo(search_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['daily_error_info', search_details];

		this.comm_module.send(packet);
	}

	getMonthlyErrorInfo(search_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['monthly_error_info', search_details];

		this.comm_module.send(packet);
	}

	// Energy Management
	getMeterPointList() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['meter_point_list'];

		this.comm_module.send(packet);
	}

	getHourlyMeter(search_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['hourly_meter', search_details];

		this.comm_module.send(packet);
	}

	getDailyMeter(search_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['daily_meter', search_details];

		this.comm_module.send(packet);
	}

	getMonthlyMeter(search_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['monthly_meter', search_details];

		this.comm_module.send(packet);
	}

	// Trend Data
	getTrendPointList() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['trend_point_list'];

		this.comm_module.send(packet);
	}

	getTrend(search_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'data';
		packet.data = ['get_trend', search_details];

		this.comm_module.send(packet);
	}

	// Realtime Energy
	getRealtimeEnergy() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'rt_en';
		packet.data = ['get_data'];

		this.comm_module.send(packet);
	}

	// JSON file read and save
	readJSONFile(file_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'read_json';
		packet.data = file_details;

		this.comm_module.send(packet);
	}

	loadImage(image_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'load_image';
		packet.data = image_details;

		this.comm_module.send(packet);
	}

	setDeviceConnection(dev_con_settings) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_dev_con';
		packet.data = dev_con_settings;

		this.comm_module.send(packet);
	}

	setControllerInfo(controller_info_settings) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_controller_info';
		packet.data = controller_info_settings;

		this.comm_module.send(packet);
	}

	setPointList(point_list) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'set_point_list';
		packet.data = point_list;

		this.comm_module.send(packet);
	}

	getZWDevices() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_get_devices';

		this.comm_module.send(packet);
	}

	zwHealNetwork() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_heal_network';

		this.comm_module.send(packet);
	}

	zwHardReset() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_init';

		this.comm_module.send(packet);
	}

	zwPairingS0() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_pairing_s0';

		this.comm_module.send(packet);
	}

	zwPairingS2() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_pairing_s2';

		this.comm_module.send(packet);
	}

	zwStopPairing() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_stop_pairing';

		this.comm_module.send(packet);
	}

	zwUnpair() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_unpair';

		this.comm_module.send(packet);
	}

	zwRmFailedNode(failedNode) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_rm_failed_node';
		packet.data = failedNode;

		this.comm_module.send(packet);
	}

	zwReplaceNode(failedNode) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_replace_node';
		packet.data = failedNode;

		this.comm_module.send(packet);
	}

	getZWDevParam(nodeID) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_get_dev_param';
		packet.data = nodeID;

		this.comm_module.send(packet);
	}

	setZWDevParam(paramPayload) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'zw_set_dev_param';
		packet.data = paramPayload;

		this.comm_module.send(packet);
	}

	saveJSONFile(file_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'save_json';
		packet.data = file_details;

		this.comm_module.send(packet);
	}

	saveImage(image_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'save_image';
		packet.data = image_details;

		this.comm_module.send(packet);
	}

	// Check Updates
	checkUpdates() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'check_update';
		//packet.data = null;

		this.comm_module.send(packet);
	}

	updateController() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'update';
		//packet.data = null;

		this.comm_module.send(packet);
	}

	// Hotel Guest Room
	getGuestRooms() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'unit_manage';
		packet.data = ['get_unit_stat'];

		this.comm_module.send(packet);
	}

	setRoomRental(rental_details) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'unit_manage';
		packet.data = ['rent_op', rental_details];

		this.comm_module.send(packet);
	}

	getControlParam() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'unit_manage';
		packet.data = ['get_control_param'];

		this.comm_module.send(packet);
	}

	setControlParam(ctrl_param) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'unit_manage';
		packet.data = ['set_control_param', ctrl_param];

		this.comm_module.send(packet);
	}

	// MSM - Multi Site Management
	getMSMSiteList() {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'msm';
		packet.data = [null, ['site_list']];

		this.comm_module.send(packet);
	}

	getMSMSiteInfo(site_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'msm';
		packet.data = [null, ['get_site', site_id]];

		this.comm_module.send(packet);
	}

	getMSMTempTargList(site_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'msm';
		packet.data = [null, ['temp_targ_list', site_id]];

		this.comm_module.send(packet);
	}

	getMSMValTargList(site_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'msm';
		packet.data = [null, ['val_targ_list', site_id]];

		this.comm_module.send(packet);
	}

	addMSMSite(site_info) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'msm';
		packet.data = [null, ['add_site', site_info]];

		this.comm_module.send(packet);
	}

	modifyMSMSite(site_info) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'msm';
		packet.data = [null, ['modify_site', site_info]];

		this.comm_module.send(packet);
	}

	deleteMSMSite(site_id) {
		let packet = {}
		packet.param1 = 'enc';
		packet.param2 = null;
		packet.command = 'msm';
		packet.data = [null, ['del_site', site_id]];

		this.comm_module.send(packet);
	}

	// For controller to receive data from SVM
	updateSVMData(data) {
		data = data[2];
		try {
			this.command_dispatch(data[0], data[1]);
		} catch (e) {
			//console.log('updateSVMData error: '+ e.message + " data = " + JSON.stringify(data));
		}
	}

	command_dispatch(command, data) {
		let comm_module = this.comm_module;
		let receiver = this.receiver;
		let controller = this;
		let packet = {};

		switch (command) {
			case 'time':
				receiver.rcvTime(data);
				break;
			case 'close':
				if (data == 'controller_disconnect') {
					// CommModule connection state Case 8
					if (controller.receiver.is_mobile) {
						controller.comm_module.ws.close();
						controller.receiver.error({
							id: 508,
							severity: 'Severe',
							message: 'Controller disconnected',
							controller_name: controller.name,
						})
					} else {
						// CommModule connection state Case 17
						//console.log('Case 17 Go to login screen')
						controller.receiver.onWSConnectionFailed();
					}
				}
				break;
			case 'login':
				this.is_logging_in = false;
				if (data.result == 'OK') {
					controller.is_logged_in = true;
					if (data.functions != null) controller.available_functions = data.functions;
					if (this.model == 'F10') controller.msm_avaliable_functions = data.functions;
					if (data.auth != null) controller.auth = data.auth;
					if (data['class'] != null) controller.user_class = data['class'];
					if (data.ver != null) controller.version = data.ver;
					if (!controller.receiver.is_mobile && data.name != null) controller.web_controller_name = data.name;
					controller.comm_module.app_login_status = 'login';
					controller.comm_module.ctrl_login_status = 'login';
					receiver.loginStatus(true);
				} else {
					if (data.result == 'no_acname' || data.result == 'wrong_passwd') {
						controller.receiver.existing_login_error = 'wrong_acc_or_pw';
						controller.receiver.error({
							id: 103,
							severity: 'Severe',
							message: 'Wrong Account Name or Password.',
							controller_name: controller.name,
						})
					} else if (data.result == 'block_period') {
						controller.receiver.existing_login_error = 'block_period';
						controller.receiver.error({
							id: 105,
							severity: 'Severe',
							message: 'Log in is blocked for 3sec because login failed.',
							controller_name: controller.name,
						})
					}
					controller.comm_module.ws.close();
					receiver.loginStatus(false);
					controller.is_logged_in = false;
				}
				break;
			case 'connect':
				if (data == 'OK') {
					packet.param1 = null;
					packet.param2 = null;
					packet.command = 'login';
					packet.data = { name: controller.username, passwd: controller.password, uuid: controller.uuid };

					controller.comm_module.send(packet);
				} else if (data == 'no_controller') {
					// CommModule connection state Case 9/15 
					controller.receiver.error({
						id: 507,
						severity: 'Severe',
						message: 'Connection to SSC established but controller not connected.',
						controller_name: controller.name,
					})
				}
				break;
			case 'sys_info':
				// decrypt and save common key
				let rsa = new NodeRSA(controller.receiver.private_key);
				let common_key = rsa.decrypt(data.common_key);
				controller.receiver.common_key = common_key;
				receiver.rcvSysInfo(data);
				// Update this controller information
				controller.model = data.model;
				controller.version = data.ver;
				controller.region = data.region;
				controller.country = data.country;
				controller.ssc_connect = data.ssc;
				controller.ssc_url = data.url;
				controller.mac_addr = data.macaddr;

				// Try to login
				packet.param1 = 'enc';
				packet.param2 = null;
				packet.command = 'login';
				packet.data = { name: controller.username, passwd: controller.password, uuid: controller.uuid };

				this.comm_module.send(packet);
				break;
			case 'mplist':
			case 'get_point_list':
				if (data.result == 'no_auth') {
					let point_list = {};
					receiver.rcvPointList(point_list);
				} else {
					receiver.rcvPointList(data);
				}
				break;
			case 'set_point_list':
				receiver.rcvSetPointList(data);
				break;
			case 'cos':
				receiver.cos(data);
				break;
			case 'logout':
				break;
			case 'op':
				if (this.op_command_src == 'operation') {

				} else if (this.op_command_src == 'point_settings') {
					receiver.rcvSetPointSettings(data);
				}
				this.op_command_src = '';
				break;
			case 'exec':
				receiver.rcvExec(data);
				break;
			case 'group':
				if (data.result == 'no_auth') {
					let groups = {};
					receiver.rcvGroups(groups);
				} else if (data[0] == 'get_groups') {
					receiver.rcvGroups(data[1]);
				} else if (data[0] == 'add') {
					receiver.rcvAddGroup(data[1]);
				} else if (data[0] == 'modify') {
					receiver.rcvModifyGroup(data[1]);
				} else if (data[0] == 'delete') {
					receiver.rcvDeleteGroup(data[1]);
				}
				break;
			case 'scene':
				if (data.result == 'no_auth') {
					let scenes = {};
					receiver.rcvScene(scenes);
				} else if (data[0] == 'get_scenes') {
					receiver.rcvScene(data[1]);
				} else if (data[0] == 'add_scene') {
					receiver.rcvAddScene(data[1]);
				} else if (data[0] == 'modify_scene') {
					receiver.rcvModifyScene(data[1]);
				} else if (data[0] == 'delete_scene') {
					receiver.rcvDeleteScene(data[1]);
				} else if (data[0] == 'exec') {
					receiver.rcvExecuteScene(data[1]);
				}
				break;
			case 'schedule':
				if (data.result == 'no_auth') {
					let schedules = {};
					receiver.rcvSchedule(schedules);
				} else if (data[0] == 'get_program') {
					receiver.rcvSchedule(data[1]);
				} else if (data[0] == 'add_program') {
					receiver.rcvAddScheduleProgram(data[1]);
				} else if (data[0] == 'modify_program') {
					receiver.rcvModifyScheduleProgram(data[1]);
				} else if (data[0] == 'delete_program') {
					receiver.rcvDeleteScheduleProgram(data[1]);
				} else if (data[0] == 'add_pattern') {
					receiver.rcvAddPattern(data[1]);
				} else if (data[0] == 'modify_pattern') {
					receiver.rcvModifyPattern(data[1]);
				} else if (data[0] == 'delete_pattern') {
					receiver.rcvDeletePattern(data[1]);
				} else if (data[0] == 'add_calendar') {
					receiver.rcvAddCalendar(data[1]);
				} else if (data[0] == 'modify_calendar') {
					receiver.rcvModifyCalendar(data[1]);
				} else if (data[0] == 'delete_calendar') {
					receiver.rcvDeleteCalendar(data[1]);
				} else if (data[0] == 'enable') {
					receiver.rcvEnableScheduleProgram(data[1]);
				}
				break;
			case 'interlock':
				if (data.result == 'no_auth') {
					let interlock = {};
					receiver.rcvInterlock(interlock);
				} else if (data[0] == 'get_program') {
					receiver.rcvInterlock(data[1]);
				} else if (data[0] == 'add_program') {
					receiver.rcvAddInterlockProgram(data[1]);
				} else if (data[0] == 'modify_program') {
					receiver.rcvModifyInterlockProgram(data[1]);
				} else if (data[0] == 'delete_program') {
					receiver.rcvDeleteInterlockProgram(data[1]);
				}else if (data[0] == 'enable') {
					receiver.rcvEnableInterlockProgram(data[1]);
				}
				break;
			case 'get_option':
				receiver.rcvOption(data);
				break;
			case 'set_option':
				receiver.rcvSetOption(data);
				break;
			case 'get_ssc':
				receiver.rcvSSC(data);
				break;
			case 'get_access':
				receiver.rcvAccess(data);
				break;
			case 'get_mail_server':
				receiver.rcvMailServer(data);
				break;
			case 'set_mail_server':
				receiver.rcvSetMailServer(data);
				break;
			case 'get_network':
				receiver.rcvNetwork(data);
				break;
			case 'get_ssid_list':
				receiver.rcvSSIDList(data);
				break;
			case 'set_network':
				receiver.rcvSetNetwork(data);
				break;
			case 'get_dev_con':
				receiver.rcvDeviceConnection(data);
				break;
			case 'set_dev_con':
				receiver.rcvSetDeviceConnection(data);
				break;
			case 'set_time':
				receiver.rcvSetTime(data);
				break;
			case 'get_controller_list':
				receiver.rcvControllerList(data);
				break;
			case 'get_account_list':
				if (data.result == 'no_auth') {
					let accounts = {};
					receiver.rcvAccounts(accounts);
				} else {
					receiver.rcvAccounts(data);
				}
				break;
			case 'get_controller_info':
				receiver.rcvControllerInfo(data);
				break;
			case 'set_controller_info':
				receiver.rcvSetControllerInfo(data);
				break;
			case 'add_account':
				receiver.rcvAddAccount(data);
				break;
			case 'modify_account':
				receiver.rcvModifyAccount(data);
				break;
			case 'delete_account':
				receiver.rcvDeleteAccount(data);
				break;
			case 'change_passwd':
				receiver.rcvChangePassword(data);
				break;
			case 'get_time_info':
				receiver.rcvTimeInfo(data);
				break;
			case 'get_timezones':
				receiver.rcvTimezones(data);
				break;
			case 'time':
				receiver.rcvSetTime(data);
				break;
			case 'changeover':
				if (data.result == 'no_auth') {
					let changeover_groups = {};
					receiver.rcvChangeoverGroups(changeover_groups);
				} else if (data[0] == 'get_groups') {
					receiver.rcvChangeoverGroups(data[1]);
				} else if (data[0] == 'add') {
					receiver.rcvAddChangeover(data[1]);
				} else if (data[0] == 'modify') {
					receiver.rcvModifyChangeover(data[1]);
				} else if (data[0] == 'delete') {
					receiver.rcvDeleteChangeover(data[1]);
				} else if (data[0] == 'enable') {
					receiver.rcvEnableChangeover(data[1]);
				}
				break;
			case 'data':
				if (data.result == 'no_auth') {
					let data = {};
					// todo handle no auth
				} else if (data[0] == 'get_history') {
					// Reverse order because current history data is in ascending order
					data[1] = data[1].reverse();
					receiver.rcvHistory(data[1]);
				}/*else if(data[0]=='hourly_op_time'){ // Not Used
					receiver.rcvHourlyOpTime(data[1]);
				}*/else if (data[0] == 'daily_op_time') {
					receiver.rcvDailyOpTime(data[1]);
				} else if (data[0] == 'monthly_op_time') {
					receiver.rcvMonthlyOpTime(data[1]);
				} else if (data[0] == 'total_op_time') {
					receiver.rcvTotalOpTime(data[1]);
				} else if (data[0] == 'daily_error_info') {
					receiver.rcvDailyErrorInfo(data[1]);
				} else if (data[0] == 'monthly_error_info') {
					receiver.rcvMonthlyErrorInfo(data[1]);
				} else if (data[0] == 'hourly_meter') {
					receiver.rcvHourlyMeter(data[1]);
				} else if (data[0] == 'daily_meter') {
					receiver.rcvDailyMeter(data[1]);
				} else if (data[0] == 'monthly_meter') {
					receiver.rcvMonthlyMeter(data[1]);
				} else if (data[0] == 'get_trend') {
					receiver.rcvTrendData(data[1]);
				} else if (data[0] == 'optime_point_list') {
					receiver.rcvOptimePointList(data[1]);
				} else if (data[0] == 'meter_point_list') {
					receiver.rcvMeterPointList(data[1]);
				} else if (data[0] == 'trend_point_list') {
					receiver.rcvTrendPointList(data[1]);
				} else if (data[0] == 'ppd_point_list') {
					receiver.rcvLoadPPDPointList(data[1]);
					break;
				} else if (data[0] == 'get_ppd') {
					receiver.rcvGetPPD(data[1]);
					break;
				} else if (data[0] == 'load_report_setting') {
					receiver.rcvLoadReportSettings(data[1]);
					break;
				} else if (data[0] == 'save_report_setting') {
					receiver.rcvSaveReportSettings(data[1]);
					break;
				}
				break;
			case 'read_json':
				if (data.result == 'OK') {
					receiver.rcvReadJSONFile(data);
				} else {
					receiver.rcvReadJSONFile({});
				}
				break;
			case 'save_json':
				receiver.rcvSaveJSONFile(data);
				break;
			case 'load_image':
				receiver.rcvLoadImage(data);
				break;
			case 'save_image':
				receiver.rcvSaveImage(data);
				break;
			case 'check_update':
				receiver.rcvCheckUpdate(data);
				break;
			case 'update':
				receiver.rcvUpdateCommandSent(data);
				break;
			case 'bill':
				switch (data[0]) {
					case 'load_owner_info':
						receiver.rcvLoadOwnerInfo(data[1]);
						break;
					case 'save_owner_info':
						receiver.rcvSaveOwnerInfo(data[1]);
						break;
					case 'load_tenant':
						receiver.rcvLoadTenant(data[1]);
						break;
					case 'save_tenant':
						receiver.rcvSaveTenant(data[1]);
						break;
					case 'load_price_info':
						receiver.rcvLoadPriceInfo(data[1]);
						break;
					case 'save_price_info':
						receiver.rcvSavePriceInfo(data[1]);
						break;
					case 'get_bill_data':
						receiver.rcvGetBillData(data[1]);
						break;
					case 'save_holiday_calendar':
						receiver.rcvSaveHolidayCalendar(data[1]);
						break;
					case 'load_holiday_calendar':
						receiver.rcvLoadHolidayCalendar(data[1]);
						break;
					case 'load_calc_option':
						receiver.rcvLoadCalcOption(data[1]);
						break;
					case 'save_calc_option':
						receiver.rcvSaveCalcOption(data[1]);
						break;
				}
				break;
			case 'zw_get_devices':
				receiver.rcvZWDevices(data);
				break;
			case 'zw_heal_network':
				receiver.rcvZWHealNetwork(data);
				break;
			case 'zw_init':
				receiver.rcvZWHardReset(data);
				break;
			case 'zw_rm_failed_node':
				receiver.rcvZWRmFailedNode(data);
				break;
			case 'zw_unpair':
				receiver.rcvZWUnpair(data);
				break;
			case 'zw_pairing_s0':
			case 'zw_pairing_s2':
				receiver.rcvZWPairing(data);
				break;
			case 'zw_stop_pairing':
				receiver.rcvZWStopPairing(data);
				break;
			case 'zw_replace_node':
				receiver.rcvZWReplaceNode(data);
				break;
			case 'zw_get_dev_param':
				receiver.rcvZWGetDevParam(data);
				break;
			case 'zw_set_dev_param':
				receiver.rcvZWSetDevParam(data);
				break;
			case 'rt_en':
				if (data == null) {
					receiver.rcvRealtimeEnergy({});
				} else if (data[0] == 'get_data') {
					receiver.rcvRealtimeEnergy(data[1]);
				} else if (data[0] == 'cos') {
					receiver.rcvRealtimeEnergyCos(data[1]);
				}
				break;
			case 'unit_manage':
				if (data[0] == 'get_unit_stat') {
					receiver.rcvGuestRoomsData(data[1]);
				} else if (data[0] == 'rent_op') {
					receiver.rcvSetRoomRental(data[1]);
				} else if (data[0] == 'get_control_param') {
					receiver.rcvGetControlParam(data[1]);
				} else if (data[0] == 'set_control_param') {
					receiver.rcvSetControlParam(data[1]);
				}
				break;
			case 'msm':
				if (data[1] != null && data[1] != undefined) {
					if (data[1][0] == 'site_list') {
						receiver.rcvMSMSiteList(data[1][1]);
					} else if (data[1][0] == 'get_site') {
						if (data[1][1].result == 'NG') {
							receiver.rcvMSMSiteInfo({});
						} else {
							receiver.rcvMSMSiteInfo(data[1][1]);
						}
					} else if (data[1][0] == 'temp_targ_list') {
						if (data[1][1].result == 'NG') {
							receiver.rcvMSMTempTargList({});
						} else {
							receiver.rcvMSMTempTargList(data[1][1]);
						}
					} else if (data[1][0] == 'val_targ_list') {
						if (data[1][1].result == 'NG') {
							receiver.rcvMSMValTargList({});
						} else {
							receiver.rcvMSMValTargList(data[1][1]);
						}
					} else if (data[1][0] == 'add_site') {
						receiver.rcvMSMAddSite(data[1][1]);
					} else if (data[1][0] == 'modify_site') {
						receiver.rcvMSMModifySite(data[1][1]);
					} else if (data[1][0] == 'del_site') {
						receiver.rcvMSMDeleteSite(data[1][1]);
					} else if (data[1][0] == 'site_stat') {
						receiver.rcvMSMSiteStat(data[1][1]);
					} else if (data[1][0] == 'cos') {
						// Change of status need to check if it is current site id
						if (this.active_site == data[0]) {
							controller.command_dispatch(data[1][0], data[1][1]);
						}
					} else {
						controller.command_dispatch(data[1][0], data[1][1]);
					}
				}
				break;
			default:
		}
	}
}